/**
 * Maps a pack definition key to its shell image URL (pack-art-image-pipeline).
 * Returns the expected URL regardless of whether the file exists on disk;
 * callers should render with `onError` to fall back to procedural art.
 *
 * Naming: one image per shell (key with _base / _shiny_boost / _talent_boost stripped).
 * ENERGY packs: `/assets/packs/energy_<type>.png`.
 * NORMAL packs: `/assets/packs/<shellKey>.png`.
 */

const stripVariantSuffix = (key: string): string =>
  key.replace(/_(base|shiny_boost|talent_boost|shiny|talent)$/i, "");

/**
 * Display name for a pack — strips tier labels and variant suffixes that are
 * communicated visually (badges, sleeve rarity label) rather than in text.
 */
export const packDisplayName = (name: string): string =>
  name
    .replace(
      /\s*\((Common|Standard|Strong|Premium|Elite|Junk|Talent Boost|Shiny Boost)\)/gi,
      "",
    )
    .trim();

export const packImageUrl = (packKey: string): string | null => {
  if (!packKey) return null;
  return `/assets/packs/${stripVariantSuffix(packKey)}.png`;
};
